<template>
    <section>
        <VideoPoup :videoData="videoData" />
        <div class="row">
            <div class="col-sm-3 cus-sidebar">
                <Sidebar />
            </div>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>
            <div v-if="!isLoading" class="col-sm-9 right-colm">
                <div class="material-box bg-white p-2">
                    <div class="row content-row ">
                        <div class="col-md-12 ">
                            <div class="row">
                                <div class="col-md-10 top-title"> 
                                    <h3>Webinar Archives - Module {{ moduleData.ModuleNumber }} - {{ moduleData.ModuleName }}</h3>
                                </div> 
                                <div class="col-md-2 top-title">
                                    <router-link :to="{ name: 'user_webinars' }">
                                        <button class="btn btn-primary">Back</button>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 ">
                            <div class="content-colm row">
                                <div class="col-md-12">
                                    <span class="df-font"> Webinars, which were conducted for Module {{
                                        moduleData.ModuleNumber }}, {{ getYear(moduleData.weeks[6].WeekEndDate) }}.</span>
                                    <hr style="height:1px;">
                                    <br>
                                </div>

                                <div class="col-md-12">
                                    <div class="material-list video">
                                        <div class="row">

                                            <div class="col-md-6">
                                                <ul>
                                                    <span v-for="(week, index) in weeks" :key="index">
                                                        <li v-if="index < 5">
                                                            <a style="color: #878888; text-decoration: none;" @click.prevent="videoModelShow(week.WebinarVimeoLink)" href="#"> Week
                                                                {{ week.WeekNumber }} - {{ week.WeekName }}</a>
                                                        </li>
                                                    </span>
                                                </ul>
                                            </div>

                                            <div class="col-md-6">
                                                <ul>
                                                    <span v-for="(week, index) in weeks" :key="index">
                                                        <li v-if="index >= 5">
                                                            <a style="color: #878888; text-decoration: none;" @click.prevent="videoModelShow(week.WebinarVimeoLink)" href="#"> Week
                                                                {{ week.WeekNumber }} - {{ week.WeekName }}</a>
                                                        </li>
                                                    </span>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Sidebar from './components/Sidebar.vue';
import userAPI from '../userApi';
import moment from 'moment'
import VideoPoup from './components/VideoPoup.vue';
// import ModuleBox from './components/ModuleBox.vue';

export default {
    name: "WebianrArchive",
    data() {
        return {
            isLoading: false,
            id: "",
            moduleData: {},
            weeksWithVideosDocuments: {},
            videoData: {
                videoSrc: ""
            },
            weeks: {},
            archiveModules: {}
        }
    },
    methods: {
        videoModelShow(src) {
            this.videoData.videoSrc ='https://player.vimeo.com/video/' + src;
            this.$bvModal.show('videoModel');
        },
        getYear(date) {
            let nowDate = new Date(moment().format('MM-DD-Y'));
            let mDate = new Date(moment(date).format('MM-DD-Y'));
            let year = moment(date).format("Y");
            if (nowDate > mDate) {
                return year;
            } else {
                return year - 1;
            }
        },
        getWebinarArchiveByModuleID() {
            this.isLoading = true;
            userAPI.getWebinarArchiveByModuleID({ moduleID: this.id }, res => {
                this.weeks = res.data.data;
                // this.moduleData = res.data.data[0];
                this.getModuleById(res.data.data[0].ModuleNumber )
                console.log('tag', this.moduleData)
                this.isLoading = false;

            }, err => {
                console.log(err);
                this.isLoading = false;

                
            })
        },           
          getModuleById(ModuleNumber) {
            
            userAPI.getModuleById({ moduleID: ModuleNumber }, res => {
                this.moduleData = res.data.data;
                console.log('ModuleNumber', this.moduleData);
                this.documentsVideosWithWeekByModule()
            }, err => {
                console.log(err);
            })
        },

    },
    mounted() {
        if (this.$route.params.id != undefined || this.$route.params.id != null) {
            this.id = this.$route.params.id;
        } else {
            this.$router.push({ name: 'user_webinars' });
        }
        this.getWebinarArchiveByModuleID()
    },
    
    components: {
        Sidebar,
        VideoPoup
    }
}
</script>